module.exports = __webpack_public_path__ + "ins09.png?d596c6a7b1b27cdbd47ec12a2af7913a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ins09.png
// module id = 160
// module chunks = 0